export const CustomEmailValidator = (value, component) => {
    if(value === null || value === undefined){
        value = '';
    }
    value = value.trim().replace(/\s\s+/g, ' ');
    if(value.trim() == '')
        return false;
    let splitItem = value.split(/[,;]/);
    let itemArray = [];
    let sortEmail;
    for(let i = 0; i < splitItem.length; i++){
        if (splitItem[i] && splitItem[i].length) {
            itemArray.push(splitItem[i].trim());
        }
    }
    //Checking valid emails 
    let regex = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})+$/;
    for(let k = 0; k < itemArray.length; k++) {
        if(!regex.test(itemArray[k]) || itemArray[k].includes("'") || itemArray[k].includes('"') ) {
            return true;
        }
    }       
    return false;
}

function extractEmails (item) {
    return item.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9._-]+)/gi);
}